import Cookies from 'js-cookie';

var confirm_participation = false;
var confirm_tc = false;
var subscribe_newsletter = false;

const submitForm = (name, fname, institution, email, subscribe_newsletter) => {
    //console.log("submitting form");
    let items = [];
    if (Cookies.get("registration_items")) {
        items = JSON.parse(Cookies.get("registration_items"));
    }

    var data = new FormData();
    data.append('action', 'anmeldung');
    data.append('name', name);
    data.append('fname', fname);
    data.append('institution', institution);
    data.append('email', email);
    data.append('nonce', cb_script_vars.nonce);
    data.append('items', JSON.stringify(items));

    fetch(cb_script_vars.ajaxurl, {
        method: "POST",
        body: data,
        credentials: "same-origin",
    })
        .then(function (res) {
            return res.json();
        })
        .then(function (data) {
            if(data.success){
                Cookies.remove("registration_items");
                window.location.href = '/anmeldung-erfolgreich';
            } else {
                alert("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.")
            }
        });
};

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

function resetView(){
    document.querySelectorAll(".event__tile").forEach(function (tile_el) {
        tile_el.classList.remove("saved");
        tile_el.style.backgroundColor = "";
        let color = tile_el.dataset.color;
        tile_el.querySelectorAll(".has_borders").forEach(function (child_el) {
            child_el.style.borderColor = color;
        });
        tile_el.querySelectorAll(".event__top").forEach(function (child_el) {
            child_el.style.backgroundColor = "";
        });
        tile_el.querySelectorAll(".event__bottom").forEach(function (child_el) {
            child_el.style.backgroundColor = "";
            child_el.innerHTML = "Zur Anmeldung hinzufügen";
        });
    });

    document
        .querySelectorAll(".registration__status")
        .forEach(function (tile_el) {
            tile_el.classList.remove("saved");
            tile_el.style.backgroundColor = "";
        });

    document.querySelectorAll(".add-event-button").forEach(function (el) {
        el.classList.remove("saved");
    });

    document.querySelectorAll(".add-event").forEach(function (el) {
        el.classList.remove("saved");
    });

    document
        .querySelectorAll(".add-event-button-text")
        .forEach(function (el) {
            el.innerHTML = "Zur Anmeldung hinzufügen";
        });

    document
        .querySelectorAll(".form-left-checkbox")
        .forEach(function (el) {
            el.style.backgroundColor = "";
        });
}

function updateView(){
    let items = [];
    if (Cookies.get("registration_items")) {
        items = JSON.parse(Cookies.get("registration_items"));
    }

    if (items) {
        for (let i = 0; i < items.length; i++) {
            let events_saved = document.querySelectorAll('.' + items[i]);
            events_saved.forEach(function (el) {
                el.classList.add("saved");
                let color = el.dataset.color;
                //el.style.backgroundColor = color;
                el.querySelectorAll(".has_borders").forEach(function (child_el) {
                    child_el.style.borderColor = "#000000";
                });
                el.querySelectorAll(".event__top").forEach(function (
                    child_el
                ) {
                    child_el.style.backgroundColor = color;
                });
                el.querySelectorAll(".event__bottom").forEach(function (
                    child_el
                ) {
                    child_el.innerHTML = "Hinzugefügt";
                    child_el.style.backgroundColor = color;
                });
                el.querySelectorAll(".add-event-button-text").forEach(function (
                    child_el
                ) {
                    child_el.innerHTML = "Hinzugefügt";
                });
                el.querySelectorAll(".checkbox").forEach(function (child_el){
                    child_el.style.backgroundColor = child_el.dataset.color;
                });
            });

        }
    } else {
        //console.log("no registrations");
    }
}

document.addEventListener("DOMContentLoaded", function() {

    updateView();

    const add_buttons = document.querySelectorAll(".add-event");

    for (var i = 0; i < add_buttons.length; i++) {
        add_buttons[i].addEventListener(
            "click",
            function (event) {
                let items = [];
                let new_event = 'event-' + this.dataset.eventid;
                if (Cookies.get("registration_items")) {
                    items = JSON.parse(Cookies.get("registration_items"));
                }
                if (!items.includes(new_event)) {
                    items.push(new_event);
                } else {
                    items.splice(items.indexOf(new_event), 1);
                }
                Cookies.set("registration_items", JSON.stringify(items));
                resetView();
                updateView();
                let anmeldung_button = document.getElementById("anmeldung__button");
                anmeldung_button.classList.add("shake-it");
                let anmeldung_button_mobile = document.getElementById(
                    "anmeldung_menu_mobile"
                );
                anmeldung_button_mobile.classList.add("shake-it");
                setTimeout(function () {
                    anmeldung_button.classList.remove("shake-it");
                    anmeldung_button_mobile.classList.remove("shake-it");
                }, 1000);
            },
            false
        );

        add_buttons[i].addEventListener('mouseover', function(event){
            this.setAttribute("style", "background-color:" + this.dataset.color + "; border-color: " + this.dataset.color + ";");
        }, false);

        add_buttons[i].addEventListener(
            "mouseout",
            function (event) {
                if (this.parentElement.classList.contains("saved")) {
                    this.setAttribute(
                        "style",
                        "background-color: " +
                            this.dataset.color +
                            "; border-color: " +
                            this.dataset.color +
                            ";"
                    );
                } else {
                    this.setAttribute(
                        "style",
                        "background-color: transparent; border-color: " +
                            this.dataset.color +
                            ";"
                    );
                }
            },
            false
        );
    }

    const checkbox_subscribe = document.getElementById("checkbox-subscribe");
    if(checkbox_subscribe){
        checkbox_subscribe.addEventListener("click", function (event) {
            this.classList.toggle("checked");
            subscribe_newsletter = !subscribe_newsletter;
        });
    }

    const checkbox_tc = document.getElementById("checkbox-tc");
    if(checkbox_tc){
        checkbox_tc.addEventListener("click", function (event) {
            this.classList.toggle("checked");
            confirm_tc = !confirm_tc;
        });
    }

    const checkbox_participation = document.getElementById("checkbox-participation");
    if(checkbox_participation){
        checkbox_participation.addEventListener("click", function (event) {
            this.classList.toggle("checked");
            confirm_participation = !confirm_participation;
        });
    }

    const anmelde_form = document.getElementById("anmeldeform");

    if (anmelde_form) {
        anmelde_form.addEventListener("submit", function (event) {
            event.preventDefault();
            let form_name_element = document.getElementById("form-name");
            let form_fname_element = document.getElementById("form-fname");
            let form_institution_element = document.getElementById("form-institution");
            let form_email_element = document.getElementById("form-email");
            //reset error messages
            form_email_element.nextElementSibling.style.display = "none";
            document.getElementById(
                "checkbox-participation"
            ).nextElementSibling.nextElementSibling.style.display = "none";
            document.getElementById(
                "checkbox-tc"
            ).nextElementSibling.nextElementSibling.style.display = "none";

            let form_valid = true;

            if (!validateEmail(form_email_element.value)) {
                form_email_element.nextElementSibling.style.display = "block";
                form_valid = false;
            }
            if(!confirm_participation){
                document.getElementById(
                    "checkbox-participation"
                ).nextElementSibling.nextElementSibling.style.display = "block";
                form_valid = false;
            }
            if(!confirm_tc){
                document.getElementById(
                    "checkbox-tc"
                ).nextElementSibling.nextElementSibling.style.display = "block";
                form_valid = false;
            }
            //validate forms
            if(form_valid){
                submitForm(
                    form_name_element.value,
                    form_fname_element.value,
                    form_institution_element.value,
                    form_email_element.value,
                    subscribe_newsletter
                );
            }
        });
    }

});